import { useState, useEffect } from 'react';
import { useAuth } from '../lib/auth';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { MessageCircle, Clock, Phone, User, AlertTriangle } from 'lucide-react';

function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function NotifCard({ notif }) {
  const isError = notif.status === 'error';
  return (
    <Card className="bg-white border border-[#E4E4E7] rounded-md hover:-translate-y-0.5 hover:shadow-md transition-all duration-200">
      <CardContent className="p-5">
        <div className="flex items-start gap-4">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isError ? 'bg-[#EF4444]/10' : 'bg-[#25D366]/10'}`}>
            {isError ? <AlertTriangle className="w-5 h-5 text-[#EF4444]" /> : <MessageCircle className="w-5 h-5 text-[#25D366]" />}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <Badge className={`text-xs ${isError ? 'bg-[#EF4444]/10 text-[#EF4444] border-[#EF4444]/30' : 'bg-[#25D366]/10 text-[#25D366] border-[#25D366]/30'}`}>
                {notif.status === 'enviado' ? 'WhatsApp Enviado' : notif.status === 'error' ? 'Error' : notif.status === 'mock' ? 'Mock' : notif.status}
              </Badge>
              {notif.twilio_sid && <span className="text-[10px] text-[#52525B] font-mono">{notif.twilio_sid}</span>}
            </div>
            <p className="text-sm text-[#0A0A0A] leading-relaxed">{notif.mensaje}</p>
            {notif.error && <p className="text-xs text-[#EF4444] mt-1">{notif.error}</p>}
            <div className="flex items-center gap-4 mt-2 text-xs text-[#52525B]">
              <span className="flex items-center gap-1"><User className="w-3 h-3" /> {notif.vecino_nombre}</span>
              <span className="flex items-center gap-1"><Phone className="w-3 h-3" /> {notif.vecino_telefono}</span>
              <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {formatDate(notif.created_at)}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function NotificacionesPage() {
  const { api } = useAuth();
  const [notificaciones, setNotificaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/notificaciones')
      .then(res => { if (!cancelled) setNotificaciones(res.data); })
      .catch(console.error)
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [api]);

  return (
    <div className="space-y-6" data-testid="notificaciones-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-[#0A0A0A]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Notificaciones</h1>
        <p className="text-base text-[#52525B] mt-1" style={{ fontFamily: 'Manrope, sans-serif' }}>Registro de mensajes WhatsApp via Twilio</p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-40"><div className="w-8 h-8 border-2 border-[#0052FF] border-t-transparent rounded-full animate-spin" /></div>
      ) : notificaciones.length === 0 ? (
        <div className="text-center py-16">
          <MessageCircle className="w-12 h-12 text-[#E4E4E7] mx-auto mb-4" />
          <p className="text-lg font-semibold text-[#0A0A0A]">Sin notificaciones</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notificaciones.map(n => <NotifCard key={n.id} notif={n} />)}
        </div>
      )}
    </div>
  );
}
